import { useState } from 'react'
import createHomeStyles from 'src/view/home/homeStyles'
import VideoPlayer from 'src/view/videoPlayer/VideoPlayer'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import { Box, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const ItemVideo1 = ({ video, isThisTheActiveVideo }) => {
  const navigate = useNavigate()
  const styles = createHomeStyles({ isThisTheActiveVideo })

  const [stateIsMouseOver, setStateIsMouseOver] = useState(false)

  const toggleItem = () => {
    navigate(`/${video.id}`)
    window.scrollTo({ top: -0, behavior: 'smooth' })
  }

  const onMouseEnterThePlayer = () => {
    setStateIsMouseOver(true)
  }

  const onMouseLeaveThePlayer = () => {
    setStateIsMouseOver(false)
  }

  const playButtonOrIsPlayingToRender = (
    <Box component="div" sx={styles.cellButtons}>
      <PlayCircleOutlineIcon sx={styles.iconPlay} />
    </Box>
  )

  return (
    <Grid container direction="row" sx={styles.videoCell} onClick={toggleItem}>
      <Grid
        size={12}
        style={styles.videoInCell}
        onMouseEnter={onMouseEnterThePlayer}
        onMouseLeave={onMouseLeaveThePlayer}
      >
        <VideoPlayer srcObj={video.src} poster={video.thumbnailUrl} play={stateIsMouseOver} />
        {playButtonOrIsPlayingToRender}
      </Grid>
      <Grid
        size={{ xs: 12 }}
        style={{
          textAlign: 'left',
          verticalAlign: 'top',
          wordWrap: 'break-word',
          width: '260px',
          height: '55px',
          whiteSpace: 'normal',
          fontSize: '16px',
          overflow: 'hidden',
          paddingTop: '8px',
          flexGrow: 1,
        }}
      >
        {video.title}
      </Grid>
    </Grid>
  )
}

export default ItemVideo1
